<template>
  <el-tooltip
    v-bind="$attrs"
    :content="content"
    :disabled="disabled"
    placement="top"
  >
    <div
      :class="['content-wrap', tooltipClass]"
      :style="{ '-webkit-line-clamp': rows }"
      @mouseenter="handleMouseenter"
    >
      <slot>{{ content }}</slot>
    </div>
    <template slot="content">
      <slot name="content">
        <div class="content-div">{{ content }}</div>
      </slot>
    </template>
  </el-tooltip>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    content: {
      type: [Number, String],
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 1
    },
    tooltipClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      disabled: false
    }
  },
  methods: {
    handleMouseenter(event) {
      const { offsetHeight, scrollHeight } = event.target
      this.disabled = scrollHeight - offsetHeight <= 2
    }
  },
}
</script>

<style lang="scss" scoped>
.content-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: initial;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.content-div {
  max-width: 500px;
  overflow: auto;
  padding: 5px 11px;
}
</style>
